<div class="top-section">
    <h3>
        Open Search Configuration
    </h3>
</div>

<section class="rate-request rate-request-sec">
    <div class="middle-section">
        <div class="container" style="margin-left: 2rem;">
            <div style="display: flex;gap: 1rem; margin-top: 1rem;">
                <div class="p-field-radiobutton" style="display: inline;">
                    <p-radioButton name="userStatus" value="LOGGEDIN" [(ngModel)]="userStatus" inputId="loggedIn"
                        (onClick)="onUserStatusChange()"></p-radioButton>
                    <label for="loggedIn" style="margin-left: 0.6rem;">Logged In</label>
                </div>

                <div class="p-field-radiobutton" style="display: inline;">
                    <p-radioButton name="userStatus" value="NONLOGGEDIN" [(ngModel)]="userStatus" inputId="nonLoggedIn"
                        (onClick)="onUserStatusChange()"></p-radioButton>
                    <label for="nonLoggedIn" style="margin-left: 0.6rem;">Non Logged In</label>
                </div>
                <div class="p-field-radiobutton" style="display: inline;">
                    <p-radioButton name="userStatus" value="ipLogs" [(ngModel)]="userStatus"
                        inputId="ipLogs"></p-radioButton>
                    <label for="ipLogs" style="margin-left: 0.6rem;">IP Logs</label>
                </div>
            </div>
            <div *ngIf="userStatus != 'ipLogs'">
                <div style="display: inline-flex; padding-top:2.5rem">
                    <div class="rate-request-form">
                        <fieldset class="scheduler-border" style="display: inline;">
                            <legend class="scheduler-border">Route Finder</legend>
                            <form [formGroup]="searchForm" (ngSubmit)="onFinderSubmit()">
                                <div class="control-group" style="display: inline-flex;">
                                    <label class="control-label input-label" for="startTime">Enable :</label>
                                    <div class="controls bootstrap-timepicker"
                                        style="margin-left: 1rem;padding-top: 0.1rem;">
                                        <input type="checkbox" formControlName="active"
                                            (change)="onEnableCLick($event,'ROUTEFINDER')" class="" />
                                    </div>
                                </div>
                                <div class="control-group" style="display: inline-flex;">
                                    <label class="control-label input-label" for="startTime">Set Default Search
                                        :</label>
                                    <div class="controls bootstrap-timepicker"
                                        style="margin-left: 1rem;padding-top: 0.1rem;">
                                        <input type="checkbox" formControlName="enableDefaultValues"
                                            (change)="onDefaultSearchCLick($event,'ROUTEFINDER')" />
                                    </div>
                                </div>
                                <div class="control-group">
                                    <div style="display: inline-flex;">
                                        <label class="control-label input-label" for="startTime">Count :</label>
                                        <div class="controls bootstrap-timepicker" style="padding-left: 0.5rem;">
                                            <input type="text" formControlName="count" name="startTime"
                                                placeholder="Free Search Count" />
                                            <i class="icon-time"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">From Country :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="fromCountry" [options]="masterSourceCountries"
                                            optionLabel="countryName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="From Country"
                                            (onChange)="onSourceCountrySelect($event,'ROUTEFINDER')">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">From Port :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="fromPort" [options]="masterSourcePorts"
                                            optionLabel="portName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="Select" (onChange)="onSourcePortChange($event,'ROUTEFINDER')">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">To Country :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="toCountry" [options]="masterDestinationCountries"
                                            optionLabel="countryName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="Select"
                                            (onChange)="onDestinationCountrySelect($event,'ROUTEFINDER')">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">To Port :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="toPort" [options]="masterDestinationPorts"
                                            optionLabel="portName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="Select">
                                        </p-dropdown>
                                    </div>
                                </div>

                                <div class="control-group">
                                    <button pButton type="submit" label="Submit"
                                        class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
                                </div>
                            </form>
                        </fieldset>
                    </div>
                    <div class="rate-request-form" style="margin-left: 3.5rem;">
                        <fieldset class="scheduler-border" style="display: inline;">
                            <form [formGroup]="trackerForm" (ngSubmit)="onShipmentTrackerSubmit()">
                                <legend class="scheduler-border">Shipment Tracker</legend>
                                <div class="control-group" style="display: inline-flex;">
                                    <label class="control-label input-label" for="startTime">Enable :</label>
                                    <div class="controls bootstrap-timepicker"
                                        style="margin-left: 1rem;padding-top: 0.1rem;">
                                        <input type="checkbox" formControlName="active"
                                            (change)="onEnableCLick($event,'SHIPMENTTRACKER')" />
                                    </div>
                                </div>
                                <div class="control-group" style="display: inline-flex;">
                                    <label class="control-label input-label" for="startTime">Set Default Search
                                        :</label>
                                    <div class="controls bootstrap-timepicker"
                                        style="margin-left: 1rem;padding-top: 0.1rem;">
                                        <input type="checkbox" formControlName="enableDefaultValues"
                                            (change)="onDefaultSearchCLick($event,'SHIPMENTTRACKER')" />
                                    </div>
                                </div>
                                <div class="control-group">
                                    <div style="display: inline-flex;">
                                        <label class="control-label input-label" for="startTime">Count :</label>
                                        <div class="controls bootstrap-timepicker" style="padding-left: 0.5rem;">
                                            <input type="text" formControlName="count" name="startTime"
                                                placeholder="Free Search Count" />
                                            <i class="icon-time"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">From Country :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="fromCountry" [options]="masterSourceCountries"
                                            optionLabel="countryName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="From Country"
                                            (onChange)="onSourceCountrySelect($event,'SHIPMENTTRACKER')">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">From Port :</label>
                                    <div class="controls bootstrap-timepicker">

                                        <p-dropdown formControlName="fromPort" [options]="trackerSourcePorts"
                                            optionLabel="portName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="Select"
                                            (onChange)="onSourcePortChange($event,'SHIPMENTTRACKER')">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">To Country :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="toCountry" [options]="trackerDestinationCountries"
                                            optionLabel="countryName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="Select"
                                            (onChange)="onDestinationCountrySelect($event,'SHIPMENTTRACKER')">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">To Port :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="toPort" [options]="trackerDestinationPorts"
                                            optionLabel="portName" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="Select">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <button pButton type="submit" label="Submit"
                                        class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
                                </div>
                            </form>
                        </fieldset>
                    </div>
                    <div class="rate-request-form" style="margin-left: 3.5rem;">
                        <fieldset class="scheduler-border" style="display: inline;">
                            <form [formGroup]="portActivitiesForm" (ngSubmit)="onPortActivitiesSubmit()">
                                <legend class="scheduler-border">Port Activities</legend>
                                <div class="control-group" style="display: inline-flex;">
                                    <label class="control-label input-label" for="startTime">Enable :</label>
                                    <div class="controls bootstrap-timepicker"
                                        style="margin-left: 1rem;padding-top: 0.1rem;">
                                        <input type="checkbox" formControlName="active"
                                            (change)="onEnableCLick($event,'PORTACTIVITIES')" />
                                    </div>
                                </div>
                                <div class="control-group" style="display: inline-flex;">
                                    <label class="control-label input-label" for="startTime">Set Default Search
                                        :</label>
                                    <div class="controls bootstrap-timepicker"
                                        style="margin-left: 1rem;padding-top: 0.1rem;">
                                        <input type="checkbox" formControlName="enableDefaultValues"
                                            (change)="onDefaultSearchCLick($event,'PORTACTIVITIES')" />
                                    </div>
                                </div>
                                <div class="control-group">
                                    <div style="display: inline-flex;">
                                        <label class="control-label input-label">Count :</label>
                                        <div class="controls bootstrap-timepicker" style="padding-left: 0.5rem;">
                                            <input type="text" formControlName="count" name="startTime"
                                                placeholder="Free Search Count" />
                                            <i class="icon-time"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label">Port :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="port" [options]="portList" optionLabel="name"
                                            [filter]="true" filterMatchMode="startsWith" placeholder="port">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">Vessels :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="vessel" [options]="vesselList" optionLabel="name"
                                            [filter]="true" filterMatchMode="startsWith" placeholder="Vessel">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <label class="control-label input-label" for="startTime">Shipping Line :</label>
                                    <div class="controls bootstrap-timepicker">
                                        <p-dropdown formControlName="shippingline" [options]="shippinglineList"
                                            optionLabel="name" [filter]="true" filterMatchMode="startsWith"
                                            placeholder="shippingline">
                                        </p-dropdown>
                                    </div>
                                </div>
                                <div class="control-group">
                                    <button pButton type="submit" label="Submit"
                                        class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
                                </div>
                            </form>
                        </fieldset>
                    </div>
                    <div class="rate-request-form" style="margin-left: 3.5rem;">
                        <fieldset class="scheduler-border" style="display: inline;">
                            <form [formGroup]="rateRequestForm" (ngSubmit)="onRateRequestSubmit()">
                                <legend class="scheduler-border">Open Cargo</legend>
                                <div class="control-group" style="display: inline-flex;">
                                    <label class="control-label input-label">Enable :</label>
                                    <div class="controls bootstrap-timepicker"
                                        style="margin-left: 1rem;padding-top: 0.1rem;">
                                        <input type="checkbox" formControlName="active" (change)="onEnableCLick($event,'RATEREQUEST')" />
                                    </div>
                                </div>
                                <div class="control-group">
                                    <div style="display: inline-flex;">
                                        <label class="control-label input-label">Count :</label>
                                        <div class="controls bootstrap-timepicker" style="padding-left: 0.5rem;">
                                            <input type="text" formControlName="count" name="startTime"
                                                placeholder="Free Search Count" />
                                            <i class="icon-time"></i>
                                        </div>
                                    </div>
                                </div>
                                 <div class="control-group">
                                    <button pButton type="submit" label="Submit"
                                        class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
                                </div>
                            </form>
                        </fieldset>
                    </div>
                </div>
            </div>
            <div *ngIf="userStatus == 'ipLogs'">
                <p-table [value]="groupedLogs" [paginator]="true" [rows]="20" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>IP</th>
                            <th>Feature</th>
                            <th>Count</th>
                            <th>City</th>
                            <th>Country</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                        <tr>
                            <td>{{ row.searchDate | date:
                                'dd/MM/yyyy' }}</td>
                            <td>{{ row.time }}</td>
                            <td>{{ row.ipAddress }}</td>
                            <td>{{ row.feature }}</td>
                            <td>{{ row.freeSearchCount }}</td>
                            <td>{{ row.city }}</td>
                            <td>{{ row.country }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</section>